import { z } from 'zod';

export const SUBSCRIPTION_PLAN_TYPES = ['BASIC', 'ADVANCED'] as const;
export type SubscriptionPlanType = (typeof SUBSCRIPTION_PLAN_TYPES)[number];
export const SubscriptionPlanTypeSchema = z.enum(SUBSCRIPTION_PLAN_TYPES);

/** Un prix en euros n'a pas plus de deux décimales (il est stocké en centimes). */
const euros = z
  .number()
  .min(0, 'Le prix ne peut pas être négatif')
  .max(100_000)
  .refine((value) => Math.abs(value * 100 - Math.round(value * 100)) < 1e-6, 'Le prix a au plus deux décimales');

/** Corps d'une modification de palier : l'identifiant vient de l'URL, les identifiants Stripe ne se changent pas ici. */
export const SubscriptionTierInputSchema = z.object({
  title: z.string().trim().max(100).optional(),
  subTitle: z.string().trim().max(150).optional(),
  maxTrees: z.number().int().positive('Le nombre d’arbres doit être positif'),
  price: euros,
  benefits: z.array(z.string().trim().min(1).max(100)).max(100),
  benefitsHtml: z.string().max(20_000).optional(),
  /** -1 = illimité, 0 = interdit. */
  maxAlignments: z.number().int().min(-1).optional(),
  maxEpaysages: z.number().int().min(-1).optional(),
});
export type SubscriptionTierInput = z.infer<typeof SubscriptionTierInputSchema>;

/** Réglages de paiement / essai gratuit : seuls les champs envoyés sont modifiés. */
export const SubscriptionPaymentSettingsSchema = z
  .object({
    requirePaymentBeforeSignup: z.boolean(),
    allowFreeTrial: z.boolean(),
    freeTrialDurationDays: z.number().int().min(1).max(365),
    freeTrialMaxTrees: z.number().int().min(0).max(10_000),
    freeTrialMaxFiches: z.number().int().min(0).max(10_000),
  })
  .partial()
  .refine((value) => Object.keys(value).length > 0, 'Aucun réglage à modifier');
export type SubscriptionPaymentSettings = z.infer<typeof SubscriptionPaymentSettingsSchema>;
